import { render, staticRenderFns } from "./BankCardFormModal.vue?vue&type=template&id=5227056f&scoped=true&"
import script from "./BankCardFormModal.vue?vue&type=script&lang=js&"
export * from "./BankCardFormModal.vue?vue&type=script&lang=js&"
import style0 from "./BankCardFormModal.vue?vue&type=style&index=0&id=5227056f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5227056f",
  null
  
)

export default component.exports